import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/GridLegacy";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
const ContactDepotMap = dynamic(() => import('./ContactDepotMap'));

const ContactDepotsMaps = (props) => {
    const { depots } = props

    return (
        <Box className="mt-4" sx={{
            padding: {
                xs: 2,
                md: 0
            }
        }}>
            <Typography className="text-center mb-5" component="h3" variant="h3">Depots</Typography>
            <Grid spacing={4} container>
                {depots.map((depot, idx) => (
                    <Grid key={idx} item xs={12} lg={6}>
                        <ContactDepotMap {...depot} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default ContactDepotsMaps